import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import { intakeFormTexts } from "../../translations/intakeFormTexts";
import SuccessModal from "./SuccessModal";

const FormIntake = ({ onClose }) => {
  const { language } = useLanguage();
  const t = intakeFormTexts[language];

  const [form, setForm] = useState({
    nombre: "",
    email: "",
    telefono: "",
    edad: "",
    objetivo: "",
    sexo: "",
    dolor: [],
    historial: [],
    alergias: "",
    medicamentos: "",
    embarazo: "",
    semanasEmbarazo: "",
    contraindicaciones: [],
    notas: "",
    consentimiento: false,
  });
  const [successModal, setSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "consentimiento") {
      setForm((prev) => ({ ...prev, consentimiento: checked }));
      return;
    }

    if (type === "checkbox") {
      setForm((prev) => ({
        ...prev,
        [name]: checked
          ? [...prev[name], value]
          : prev[name].filter((item) => item !== value),
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  const response = await fetch("https://formspree.io/f/mgvrblen", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(form),
  });

if (response.ok) {
  setSuccessModal(true);
} else {
  alert(t.errorMessage);
}
};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center p-6 z-50">
      <div className="bg-white p-8 rounded-2xl w-full max-w-lg shadow-2xl overflow-y-auto max-h-[90vh]">
        <h2 className="text-2xl font-bold mb-6 text-center">{t.title}</h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-6">
          {/* DATOS PERSONALES */}
          <div>
            <h3 className="text-lg font-semibold mb-2">{t.personalData}</h3>

            <input
              type="text"
              name="nombre"
              placeholder={t.namePlaceholder}
              required
              className="border p-3 rounded-lg w-full mb-3"
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder={t.emailPlaceholder}
              required
              className="border p-3 rounded-lg w-full mb-3"
              onChange={handleChange}
            />
            <input
              type="tel"
              name="telefono"
              placeholder={t.phonePlaceholder}
              required
              className="border p-3 rounded-lg w-full mb-3"
              onChange={handleChange}
            />
            <input
  type="number"
  name="edad"
  placeholder={t.agePlaceholder}
  required
  className="border p-3 rounded-lg w-full"
  onChange={handleChange}
/>

{/* SEXO */}

<div className="mt-4">

  <h3 className="text-lg font-semibold mb-3">
    {
      language === "es"
        ? "Sexo"
        : language === "it"
        ? "Sesso"
        : language === "is"
        ? "Kyn"
        : language === "de"
        ? "Płeć"
        : "Gender"
    }
  </h3>

  <div className="grid grid-cols-2 gap-3">

    <button
      type="button"
      onClick={() =>
        setForm((prev) => ({
          ...prev,
          sexo: "hombre",
          embarazo: "",
          semanasEmbarazo: ""
        }))
      }
      className={`p-3 rounded-xl border transition ${
        form.sexo === "hombre"
          ? "bg-blue-900 text-white border-blue-900"
          : "bg-white text-gray-700 border-gray-300"
      }`}
    >
      {
        language === "es"
          ? "♂ Hombre"
          : language === "it"
          ? "♂ Uomo"
          : language === "is"
          ? "♂ Karl"
          : language === "de"
          ? "♂ Mężczyzna"
          : "♂ Male"
      }
    </button>

    <button
      type="button"
      onClick={() =>
        setForm((prev) => ({
          ...prev,
          sexo: "mujer"
        }))
      }
      className={`p-3 rounded-xl border transition ${
        form.sexo === "mujer"
          ? "bg-blue-900 text-white border-blue-900"
          : "bg-white text-gray-700 border-gray-300"
      }`}
    >
      {
        language === "es"
          ? "♀ Mujer"
          : language === "it"
          ? "♀ Donna"
          : language === "is"
          ? "♀ Kona"
          : language === "de"
          ? "♀ Kobieta"
          : "♀ Female"
      }
    </button>

  </div>

</div>
          </div>

          {/* OBJETIVO */}
          <div>
            <h3 className="text-lg font-semibold mb-2">{t.objectiveTitle}</h3>
            <select
              name="objetivo"
              required
              className="border p-3 rounded-lg w-full"
              onChange={handleChange}
            >
              <option value="">{language === "es" ? "Seleccionar" : "Select"}</option>
              {t.objectiveOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>

          {/* DOLOR */}
          <div>
            <h3 className="text-lg font-semibold mb-2">{t.painAreasTitle}</h3>
            <div className="grid grid-cols-2 gap-2">
              {t.painAreas.map((item) => (
                <label key={item} className="text-sm">
                  <input
                    type="checkbox"
                    name="dolor"
                    value={item}
                    onChange={handleChange}
                  />
                  <span className="ml-2">{item}</span>
                </label>
              ))}
            </div>
          </div>

          {/* HISTORIAL */}
          <div>
            <h3 className="text-lg font-semibold mb-2">{t.medicalHistoryTitle}</h3>
            <div className="grid grid-cols-2 gap-2">
              {t.medicalHistory.map((item) => (
                <label key={item} className="text-sm">
                  <input
                    type="checkbox"
                    name="historial"
                    value={item}
                    onChange={handleChange}
                  />
                  <span className="ml-2">{item}</span>
                </label>
              ))}
            </div>
          </div>

          {/* ALERGIAS / MEDICAMENTOS */}
          <div>
            <h3 className="text-lg font-semibold mb-2">{t.allergiesTitle}</h3>
            <input
              type="text"
              name="alergias"
              placeholder={t.alergiesPlaceholder}
              className="border p-3 rounded-lg w-full mb-3"
              onChange={handleChange}
            />
            <input
              type="text"
              name="medicamentos"
              placeholder={t.medicationsPlaceholder}
              className="border p-3 rounded-lg w-full"
              onChange={handleChange}
            />
          </div>

          {/* EMBARAZO */}
          {form.sexo !== "hombre" && (
          <div>
            <h3 className="text-lg font-semibold mb-2">{t.pregnancyTitle}</h3>
            <select
              name="embarazo"
              className="border p-3 rounded-lg w-full"
              onChange={handleChange}
            >
              <option value="">
                {language === "es" ? "Seleccionar" : "Select"}
              </option>
              <option value="No">{language === "es" ? "No" : "No"}</option>
              <option value="Sí">{language === "es" ? "Sí" : "Yes"}</option>
            </select>

            {form.embarazo === (language === "es" ? "Sí" : "Yes") && (
              <input
                type="number"
                name="semanasEmbarazo"
                placeholder={t.pregnancyWeeksPlaceholder}
                className="border p-3 rounded-lg w-full mt-2"
                onChange={handleChange}
              />
            )}
          </div>

)}
          {/* CONTRAINDICACIONES */}
          <div>
            <h3 className="text-lg font-semibold mb-2">{t.contraindicationsTitle}</h3>
            <div className="grid grid-cols-1 gap-2">
              {t.contraindications.map((item) => (
                <label key={item} className="text-sm">
                  <input
                    type="checkbox"
                    name="contraindicaciones"
                    value={item}
                    onChange={handleChange}
                  />
                  <span className="ml-2">{item}</span>
                </label>
              ))}
            </div>
          </div>

          {/* NOTAS */}
          <div>
            <h3 className="text-lg font-semibold mb-2">{t.notesTitle}</h3>
            <textarea
              name="notas"
              placeholder={t.notesPlaceholder}
              className="border p-3 rounded-lg w-full h-28"
              onChange={handleChange}
            />
          </div>

          {/* CONSENTIMIENTO */}
          <div className="mt-2">
            <label className="flex items-start gap-3 text-sm">
              <input
                type="checkbox"
                name="consentimiento"
                required
                className="mt-1"
                onChange={handleChange}
              />
              <span>{t.consentText}</span>
            </label>
          </div>

          {/* BOTÓN */}
          <button className="bg-indigo-600 text-white py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition">
            {t.sendButton}
          </button>

          <button
            type="button"
            className="text-gray-500 text-sm underline mt-2"
            onClick={onClose}
          >
            {t.closeButton}
          </button>
         </form>
      </div>

      <SuccessModal
        isOpen={successModal}
        message={t.successMessage}
        language={language}
        onClose={() => {
          setSuccessModal(false);
          onClose();
        }}
      />

    </div>
  );
};

export default FormIntake;
